import {
  GetSessionGuardrailTreesResponse,
  GetSessionTreesRequest,
} from "@financial-advisory/data-access/api-types";
import { productRecommendationApi } from "./productRecommendationApi";

export const {
  useGetSessionGuardrailTreesQuery,
  useLazyGetSessionGuardrailTreesQuery,
} = productRecommendationApi.injectEndpoints({
  endpoints: (builder) => ({
    getSessionGuardrailTrees: builder.query<
      GetSessionGuardrailTreesResponse,
      GetSessionTreesRequest
    >({
      query: ({ sessionVersionId }) => ({
        url: `sessions/${sessionVersionId}/guardrails`,
        method: "GET",
      }),
    }),
  }),
});
